import { Button } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { useSession } from '@/auth/index';
import { SearchFormProps } from '@/components/SearchFormsContainer/interfaces';
import { useAppConfigContext } from '@/context/AppConfig';
import { useAppConstantsContext } from '@/context/AppConstants';
import { emailSearch } from '@/reports/SearchEmailForm/emailSearch';
import type { EmailSearchParams } from '@/reports/SearchEmailForm/emailSearch';
import type { SearchReportResponseData } from '@/reports/searchReport';
import { Text, styled } from '@/theme/index';

const Wrapper = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(2.5),
  marginTop: theme.spacing(2.5),
}));

const FlexContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1.5),
  width: '100%',
  flexDirection: 'column',
  alignItems: 'center',
}));

export function DarkWebFindOutWhatElse({
  onSuccess,
  onError,
}: SearchFormProps) {
  const {
    session: { account },
  } = useSession();
  const { logError } = useAppConfigContext();
  const emailQuery = useMutation<
    SearchReportResponseData,
    Error,
    EmailSearchParams
  >({
    mutationFn: emailSearch,
    onSuccess: (data, variables) => {
      onSuccess &&
        onSuccess({
          permalink: data.report.permalink,
          reportType: 'email',
          searchParams: `email=${encodeURIComponent(variables.email)}`,
        });
    },
    onError: (error) => {
      logError('Email Search', error);
      onError && onError(error);
    },
  });

  const {
    images: { imgDarkWebEmail },
  } = useAppConstantsContext();

  return (
    <Wrapper>
      <FlexContainer>
        <img src={imgDarkWebEmail || ''} alt="dark web email" width="60px" />
        <Text variant="h3" mb="0" fontWeight="bold" textAlign="center">
          Find out what else is linked to this email
        </Text>
        <Button
          variant="contained"
          color="success"
          fullWidth
          sx={{ maxWidth: 172 }}
          onClick={(e) => {
            e.preventDefault();
            emailQuery.mutate({
              email: account?.account.user_info.email || '',
            });
          }}
        >
          View Email Report
        </Button>
      </FlexContainer>
    </Wrapper>
  );
}
